export const updateHeaders = (API_ENDPOINT, X_HOST_HEADER) => {
  const clonedApiEndpoint = JSON.parse(JSON.stringify(API_ENDPOINT));

  for (const key in clonedApiEndpoint) {
    if (clonedApiEndpoint[key].headers) {
      if (typeof clonedApiEndpoint[key].headers === 'string' && X_HOST_HEADER[clonedApiEndpoint[key].headers]) {
        clonedApiEndpoint[key].headers = { ...X_HOST_HEADER[clonedApiEndpoint[key].headers] };
      }
    }
  }

  return clonedApiEndpoint;
};
